import { HttpService } from '@/infra'

export type TAtendimentoEncerradoResponse = {
  id: string
  message: string
  date: string
  data: {
    duracao: `${string}:${string}:${string}`
  }
}

export class EncerrarAtendimentoService extends HttpService {
  async execute(id: string) {
    const response = await this.http.patch<TAtendimentoEncerradoResponse>(
      `/api/v2/Atendimento/encerrarAtendimento/${id}`,
      {},
    )
    return response.data
  }
}
